import { render, staticRenderFns } from "./pieTaskCood.vue?vue&type=template&id=68ec853c&"
import script from "./pieTaskCood.vue?vue&type=script&lang=js&"
export * from "./pieTaskCood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports